import type { ProviderStatus } from '@/shared/hooks/useProviderStatus';

/**
 * GH#887 — el texto del aviso se arma por CAPACIDAD, con lo que de verdad no es live.
 * Antes era un texto fijo («MODO DEMO — pagos y NCF simulados») que salia siempre: no
 * mencionaba PayPal, nombraba a Stripe (que ya no es un metodo de cobro) y afirmaba cosas
 * sobre capacidades que si estaban conectadas.
 *
 *   cobros                          paypal no es 'live' (o el payload no trae paypal)
 *   comprobantes fiscales (NCF)     NINGUN proveedor e-CF es 'live' (alanube e idecus)
 *   SMS                             twilio no es 'live'
 *   WhatsApp                        whatsapp no es 'live'
 *
 * `stripe` no cuenta: es «proximamente», no un cobro ofrecido.
 */
export type Capacidad = 'cobros' | 'ncf' | 'sms' | 'whatsapp';

const ETIQUETA: Record<Capacidad, string> = {
  cobros: 'cobros',
  ncf: 'comprobantes fiscales (NCF)',
  sms: 'SMS',
  whatsapp: 'WhatsApp',
};

const EFECTO: Record<Capacidad, string> = {
  cobros: 'ningun cobro toca dinero',
  ncf: 'ningun comprobante llega a DGII',
  sms: 'no se envian SMS reales',
  whatsapp: 'no se envian mensajes reales de WhatsApp',
};

export const capacidadesNoLive = (s: ProviderStatus): Capacidad[] => {
  const out: Capacidad[] = [];
  if (s.paypal !== 'live') out.push('cobros');
  if (s.alanube !== 'live' && s.idecus !== 'live') out.push('ncf');
  if (s.twilio !== 'live') out.push('sms');
  if (s.whatsapp !== 'live') out.push('whatsapp');
  return out;
};

const unir = (items: string[]): string =>
  items.length <= 1
    ? items.join('')
    : `${items.slice(0, -1).join(', ')} y ${items[items.length - 1]}`;

export interface TextoAviso {
  titulo: string;
  detalle: string;
}

/** null = todo live, el aviso no se muestra. */
export const textoAviso = (s: ProviderStatus): TextoAviso | null => {
  const caps = capacidadesNoLive(s);
  if (caps.length === 0) return null;
  return {
    titulo: `AVISO — ${unir(caps.map((c) => ETIQUETA[c]))}: aun sin conexion real.`,
    detalle: `Mientras tanto ${unir(caps.map((c) => EFECTO[c]))}.`,
  };
};

/** La consulta de estado fallo: NO se afirma «simulado», se dice que no se pudo verificar. */
export const TEXTO_NO_VERIFICADO: TextoAviso = {
  titulo: 'AVISO — no se pudo verificar el estado de cobros y comprobantes.',
  detalle:
    'No podemos confirmar si los cobros, los comprobantes fiscales y los envios estan conectados. Recarga la pagina para reintentar.',
};
